import { render, staticRenderFns } from "./ReceptionAvis.vue?vue&type=template&id=34c47c49"
import script from "./ReceptionAvis.vue?vue&type=script&lang=js"
export * from "./ReceptionAvis.vue?vue&type=script&lang=js"
import style0 from "./ReceptionAvis.vue?vue&type=style&index=0&id=34c47c49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports